<template>
  <div class="w-full">
    <v-chart v-loading="chartLoading" :options="option" autoresize class="w-full h-150px"></v-chart>
  </div>
</template>

<script>
export default {
  name: 'bar-chart',
  props: {
    values: {
      type: Object,
      default: () => {},
    },
  },
  computed: {
    option() {
      const _that = this
      return {
        color: ['#ff8d01', '#00bcc8'],
        title: {
          text: '安全隐患',
          left: '14%',
          top: '40%',
          textStyle: {
            fontSize: 12,
            color: 'rgba(255, 255, 255, 0.8)',
            fontWeight: 'normal',
          },
        },
        // tooltip: {
        //   trigger: 'item',
        // },
        legend: {
          orient: 'vertical',
          right: '8%',
          top: '22%',
          itemWidth: 13,
          itemHeight: 13,
          itemGap: 30,
          borderRadius: 0,
          textStyle: {
            color: 'rgba(255, 255, 255, 0.8)',
            rich: {
              name: {
                fontSize: 12,
                padding: [0, 10, 0, 0],
              },
              value: {
                fontSize: 12,
                color: 'rgba(255, 255, 255, 0.8)',
                backgroundColor: 'transparent',
                align: 'right',
                padding: [0, 10, 0, 0],
              },
            },
          },
        },
        formatter(name) {
          let value = null
          _.forEach(_that.dataList, (item) => {
            if (item.name === name) {
              value = item.value
            }
          })

          const v = value
          return [`{name|${name}}{value|${v}}`].join('')
        },
        series: [
          {
            type: 'pie',
            roseType: 'radius',
            radius: ['50%', '80%'],
            center: ['25%', '45%'],
            data: this.dataList,
            label: {
              show: false,
            },
          },
        ],
      }
    },
  },
  data() {
    return {
      chartLoading: false,
      dataList: [
        {
          value: 0,
          name: '重大隐患',
        },
        {
          value: 0,
          name: '一般隐患',
        },
      ],
    }
  },
}
</script>

<style lang="scss" scoped></style>
